/**
 * @file devemos declarar aqui as chaves de objetos e dados armazenados na session-storage.
 * Usar sempre maiusculo, tanto para o nome de constantes, quanto para os valores.
 * Valores fora do padrão para manter a compatibilidade com valores já sendo usados
 * pela aplicação.
 */

export const DATA_LEAD = 'dataLead';
export const DATA_FORM = 'dataForm';
export const DATA_PIX = 'dataPix';
export const GIFT_SELECTION = 'giftSelection';
export const DEFAULT_SELECTED_PLAN = 'defaultSelectedPlan';
export const IS_PAYMENT_IN_PERSON = 'isPaymentInPerson';
export const NU_PAY_INFOS = 'NU_PAY_INFOS';
export const PIX_V3_PAYMENT_DATA = 'PIX_V3_PAYMENT_DATA';
export const PURCHASED_PROFILES_AMOUNT = 'PURCHASED_PROFILES_AMOUNT';
export const PURCHASED_PLAN = 'PURCHASED_PLAN';
export const PURCHASED_ITEMS_QUANTITY = 'PURCHASED_ITEMS_QUANTITY';
/**
 * FIN-7470 (ASS-09): contexto da autenticação 3DS entre etapas. Fica aqui e
 * nunca em query param — provider pode descartar a query no retorno.
 */
export const THREE_DS_CONTEXT = 'THREE_DS_CONTEXT';
